import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Action, Mutation } from 'vuex-module-decorators';
import { ISectionMenuItem, ISectionOptionType, ISectionTypes } from '~/types/componentTypes';

@InjectModule({ stateFactory: true }, module)
export default class SectionModule extends InjectVuexModule {
    public SECTIONS: ISectionTypes[] = [
        {
            id: 111,
            sectionTitle: 'Patient',
            selected: false,
            options: [
                {
                    id: 1,
                    title: 'Enroll in Copay Assistance',
                    navTitle: 'Enroll in Copay Assistance',
                    selected: false,
                    menuItems: [
                        {
                            id: 'a',
                            title: 'Eligibility',
                            route: '/patient/eligibility/',
                            completed: false,
                        },
                        {
                            id: 'b',
                            title: 'Patient Information',
                            route: '/patient/patient-information/',
                            completed: false,
                        },
                        // {
                        //     id: 'c',
                        //     title: 'Health Insurance Information',
                        //     route: '/patient/health-insurance-information/',
                        //     completed: false,
                        // },
                        // {
                        //     id: 'd',
                        //     title: 'Prescriber Information',
                        //     route: '/patient/prescriber-information/',
                        //     completed: false,
                        // },
                        {
                            id: 'c',
                            title: 'Patient Consent',
                            route: '/patient/patient-consent/',
                            completed: false,
                        },
                    ],
                },
                {
                    id: 2,
                    title: 'Upload Documents',
                    navTitle: 'Upload Documents',
                    selected: false,
                    menuItems: [
                        {
                            id: 'd',
                            title: 'Document Upload',
                            route: '/upload-documents/',
                            completed: false,
                        },
                    ],
                },
                // {
                //     id: 3,
                //     title: 'E-Consent (Patient Authorization)',
                //     navTitle: 'E-Consent (Patient Authorization)',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: '',
                //             title: 'Patient Information',
                //             route: '/patient/patient-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Patient Authorization',
                //             route: '/patient/patient-authorization/',
                //             completed: false,
                //         },
                //     ],
                // },
                // {
                //     id: 4,
                //     title: 'Request Nurse Injection Training',
                //     navTitle: 'Request Nurse Injection Training',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: '',
                //             title: 'Patient Information',
                //             route: '/patient/patient-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Prescriber Information',
                //             route: '/patient/prescriber-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Patient Authorization',
                //             route: '/patient/patient-authorization/',
                //             completed: false,
                //         },
                //     ],
                // },
                // {
                //     id: 5,
                //     title: 'Request GlatopaJect<sup>®</sup> Device',
                //     navTitle: 'Request Glatopaject<sup>®</sup> Device',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: '',
                //             title: 'Patient Information',
                //             route: '/patient/patient-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Prescriber Information',
                //             route: '/patient/prescriber-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Patient Authorization',
                //             route: '/patient/patient-authorization/',
                //             completed: false,
                //         },
                //     ],
                // },
            ],
        },
        {
            id: 222,
            sectionTitle: 'Healthcare Provider',
            selected: false,
            options: [
                // {
                //     id: 6,
                //     title: 'Enroll Patient in Support Services',
                //     navTitle: 'Enroll in Patient Support Services',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: '',
                //             title: 'Getting Started',
                //             route: '/hcp/getting-started/',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Patient Information',
                //             route: '/hcp/patient-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Health Insurance Information',
                //             route: '/hcp/health-insurance-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Diagnosis Information',
                //             route: '/hcp/diagnosis-information',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Prescriber Information',
                //             route: '/hcp/prescriber-information/',
                //             completed: false,
                //         },
                //         {
                //             id: '',
                //             title: 'Pharmacy Information',
                //             route: '/hcp/pharmacy-information/',
                //             completed: false,
                //         },
                //     ],
                // },
                {
                    id: 7,
                    title: 'Enroll Patient in Copay Assistance',
                    navTitle: 'Enroll Patient in Copay Assistance',
                    selected: false,
                    menuItems: [
                        {
                            id: 'e',
                            title: 'Eligibility',
                            route: '/hcp/eligibility/',
                            completed: false,
                        },
                        {
                            id: 'f',
                            title: 'Patient Information',
                            route: '/hcp/patient-information/',
                            completed: false,
                        },
                        // {
                        //     id: 'i',
                        //     title: 'Health Insurance Information',
                        //     route: '/hcp/health-insurance-information/',
                        //     completed: false,
                        // },
                        // {
                        //     id: 'j',
                        //     title: 'Prescriber Information',
                        //     route: '/hcp/prescriber-information/',
                        //     completed: false,
                        // },
                    ],
                },
                {
                    id: 8,
                    title: 'Upload Documents',
                    navTitle: 'Upload Documents',
                    selected: false,
                    menuItems: [
                        {
                            id: 'g',
                            title: 'Document Upload',
                            route: '/upload-documents/',
                            completed: false,
                        },
                    ],
                },
            ],
        },
        // {
        //     id: 333,
        //     sectionTitle: 'Pharmacy',
        //     selected: false,
        //     options: [
        //         {
        //             id: 9,
        //             title: 'Enroll Patient in Co-Pay Assistance',
        //             navTitle: 'Enroll Patient in Co-Pay Assistance',
        //             selected: false,
        //             menuItems: [
        //                 // {
        //                 //     id: '',
        //                 //     title: 'NCPDP Input',
        //                 //     route: '/pharmacy/ncpdp/',
        //                 //     completed: false,
        //                 // },
        //                 {
        //                     id: 'l',
        //                     title: 'Eligibility',
        //                     route: '/pharmacy/eligibility/',
        //                     completed: false,
        //                 },
        //                 {
        //                     id: 'm',
        //                     title: 'Patient Information',
        //                     route: '/pharmacy/patient-information/',
        //                     completed: false,
        //                 },
        //                 // {
        //                 //     id: 'n',
        //                 //     title: 'Health Insurance Information',
        //                 //     route: '/pharmacy/health-insurance-information/',
        //                 //     completed: false,
        //                 // },
        //                 // {
        //                 //     id: 'o',
        //                 //     title: 'Prescriber Information',
        //                 //     route: '/pharmacy/prescriber-information/',
        //                 //     completed: false,
        //                 // },
        //             ],
        //         },
        //         // {
        //         //     id: 10,
        //         //     title: 'Request GlatopaJect<sup>®</sup> Device',
        //         //     navTitle: 'Request Services',
        //         //     selected: false,
        //         //     menuItems: [
        //         //         {
        //         //             id: '',
        //         //             title: 'Pharmacy Information',
        //         //             route: '/pharmacy/pharmacy-information/',
        //         //             completed: false,
        //         //         },
        //         //     ],
        //         // },
        //     ],
        // },
    ];

    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    public isPssFlow: boolean = false;
    public get isPatientPath() {
        const patientPathId = 111;
        return this.SECTIONS.find(path => path.id === patientPathId)?.selected;
    }

    public get isHcpPath() {
        const HcpPathId = 222;
        return this.SECTIONS.find(path => path.id === HcpPathId)?.selected;
    }

    public get isPharmacyPath() {
        const pharmacyPathId = 333;
        return this.SECTIONS.find(path => path.id === pharmacyPathId)?.selected;
    }

    public get isHcpSupportService() {
        const HcpPathId = 6;
        return this.SECTIONS.find(path => path.options.find(hcpPath => hcpPath.id === HcpPathId)?.selected)?.selected
    }

    public get anyPathSelected() {
        return this.SECTIONS.some(section => section.options.some(option => option.selected));
    }

    public get nothingSelected() {
        return this.SECTIONS.every(section => !section.selected);
    }

    public get activeSection() {
        return this.SECTIONS.map(section => ({
            ...section,
            options: section.options.filter(option => option.selected),
        })).filter(section => section.selected || section.options.length > 0);
    }

    get activeUniqueMenuItems(): ISectionOptionType {
        const uniqueMenuItemsSet = new Set<string>();
        const activeOptions: ISectionOptionType[] = this.SECTIONS.flatMap(section =>
            section.options
                .filter(option => option.selected)
                .map(option => ({
                    ...option,
                    menuItems: option.menuItems.filter(menuItem => {
                        const isUnique = !uniqueMenuItemsSet.has(menuItem.id);
                        if (isUnique) uniqueMenuItemsSet.add(menuItem.id);
                        return isUnique;
                    }),
                }))
                .filter(option => option.menuItems.length > 0)
                .sort((a, b) => (a.id > b.id ? 1 : a.id < b.id ? -1 : 0))
        );
        return activeOptions[0];
    }

    @Mutation
    public resetSelections() {
        this.SECTIONS.forEach(element => {
            element.selected = false;
            element.options.forEach(option => {
                option.selected = false;
                option.menuItems.forEach(menu => {
                    menu.completed = false;
                });
            });
        });
    }

    @Mutation
    public handleSelectionPath({ section, optionIndex }: { section: ISectionTypes; optionIndex: number }) {
        this.SECTIONS.forEach(element => {
            element.selected = false;
            element.options.forEach(option => {
                option.selected = false;
            });
        });
        this.isPssFlow = section.options[optionIndex].navTitle === 'Enroll in Patient Support Services';
        section.options[optionIndex].selected = true;
        section.selected = true;
    }

    @Mutation
    public resetPssFlow() {
        this.isPssFlow = false;
    }

    @Mutation
    public enableSection(section: ISectionTypes) {
        const wasAlreadyActive = section.selected;
        this.SECTIONS.forEach(element => {
            element.selected = false;
            element.options.forEach(option => {
                option.selected = false;
            });
        });
        if (!wasAlreadyActive) {
            section.selected = true;
        }
    }

    @Mutation
    public completeMenuItem(menuItem: ISectionMenuItem) {
        menuItem.completed = true;
    }

    @Action
    public nextMenuItem(route: string) {
        const allMenuItemsWithHeading: ISectionOptionType = this.activeUniqueMenuItems;

        const currentRoute = (this as any).$router?.currentRoute || {};
        const routeQuery = currentRoute.query || {};
        const routePath = currentRoute.path || '';

        const isEconsentPath =
            routeQuery.path === 'econsent' ||
            routePath.includes('/path=econsent') ||
            routePath.includes('/?path=econsent') ||
            routeQuery.econsent === '' ||
            routeQuery.econsent === 'true';

        if (isEconsentPath) {
            if (!allMenuItemsWithHeading || !allMenuItemsWithHeading.menuItems) {
                const sections = (this as any).SECTIONS || [];
                const patientSection = sections.find((section: ISectionTypes) => section.id === 111);
                if (patientSection) {
                    const eConsentOption = patientSection.options.find((option: ISectionOptionType) => option.id === 3);
                    if (eConsentOption && eConsentOption.menuItems) {
                        // Find current route in E-Consent menu items
                        const idx = eConsentOption.menuItems.findIndex((obj: ISectionMenuItem) => obj.route === route);
                        if (idx !== -1 && idx < eConsentOption.menuItems.length) {
                            // Mark current menu item as completed
                            this.context.commit('completeMenuItem', eConsentOption.menuItems[idx]);
                            if (idx < eConsentOption.menuItems.length - 1) {
                                return eConsentOption.menuItems[idx + 1].route;
                            }
                        }
                    }
                }

                console.error('Error: Could not find next menu item in E-Consent flow');
                return undefined;
            }
        }

        const idx = allMenuItemsWithHeading.menuItems.findIndex(obj => obj.route === route);
        if (idx !== -1 && idx < allMenuItemsWithHeading.menuItems.length) {
            this.context.commit('completeMenuItem', allMenuItemsWithHeading.menuItems[idx]);
            if (idx < allMenuItemsWithHeading.menuItems.length - 1) {
                return allMenuItemsWithHeading.menuItems[idx + 1].route;
            } else {
                return undefined;
            }
        } else {
            return undefined;
        }
    }

    @Action
    public prevoiusMenuItem(route: string) {
        const allMenuItemsWithHeading: ISectionOptionType = this.activeUniqueMenuItems;

        const currentRoute = (this as any).$router?.currentRoute || {};
        const routeQuery = currentRoute.query || {};
        const routePath = currentRoute.path || '';

        const isEconsentPath =
            routeQuery.path === 'econsent' ||
            routePath.includes('/path=econsent') ||
            routePath.includes('/?path=econsent') ||
            routeQuery.econsent === '' ||
            routeQuery.econsent === 'true';

        if (isEconsentPath) {
            if (!allMenuItemsWithHeading || !allMenuItemsWithHeading.menuItems) {
                const sections = (this as any).SECTIONS || [];
                const patientSection = sections.find((section: ISectionTypes) => section.id === 111);
                if (patientSection) {
                    const eConsentOption = patientSection.options.find((option: ISectionOptionType) => option.id === 3);
                    if (eConsentOption && eConsentOption.menuItems) {
                        // Find current route in E-Consent menu items
                        const idx = eConsentOption.menuItems.findIndex((obj: ISectionMenuItem) => obj.route === route);
                        if (idx > 0) {
                            return eConsentOption.menuItems[idx - 1].route;
                        }
                    }
                }

                return '/';
            }
        }

        const idx = allMenuItemsWithHeading.menuItems.findIndex(obj => obj.route === route);
        if (idx > 0) {
            return allMenuItemsWithHeading.menuItems[idx - 1].route;
        } else {
            return '/';
        }
    }
}
